/**
 * Destinatarios del redactor (M3 y M5, auditoría 2026-10-02).
 *
 * M5: el campo aceptaba «;» (costumbre de Outlook) pero el envío solo partía por
 *     «,»: «a@x.mx; b@y.mx» salía como UNA dirección inválida y el rechazo llegaba
 *     tarde, como error SMTP.
 * M3: «Responder a todos» dejaba fuera a los demás del Para.
 */

const EMAIL_RE = /^[^\s@<>()",;:]+@[^\s@<>()",;:]+\.[^\s@<>()",;:]+$/;

/** Parte «a@x.mx; Ana <b@y.mx>, "Pérez, Juan" <c@z.mx>» en sus direcciones.
 *  Respeta las comillas: una coma dentro del nombre no corta. */
export function separarDirecciones(texto) {
  const partes = [];
  let actual = '';
  let enComillas = false;
  let enAngulos = false;
  for (const ch of String(texto || '')) {
    if (ch === '"') enComillas = !enComillas;
    else if (ch === '<' && !enComillas) enAngulos = true;
    else if (ch === '>' && !enComillas) enAngulos = false;
    if ((ch === ',' || ch === ';' || ch === '\n') && !enComillas && !enAngulos) {
      partes.push(actual);
      actual = '';
    } else {
      actual += ch;
    }
  }
  partes.push(actual);
  return partes.map((p) => p.trim()).filter(Boolean);
}

/** La dirección de una parte: lo que va entre <…> o la parte entera. */
export function direccionDe(parte) {
  const m = String(parte || '').match(/<([^>]*)>/);
  return (m ? m[1] : String(parte || '')).trim();
}

/** Las partes cuya dirección no tiene forma de correo. */
export function direccionesInvalidas(...campos) {
  return campos.flatMap(separarDirecciones).filter((p) => !EMAIL_RE.test(direccionDe(p)));
}

/**
 * Para y Cc de una respuesta.
 *   · Responder: a quien pidió que le respondieran (Reply-To) o, si no, al remitente.
 *   · Responder a todos: eso + el resto del Para en «Para», y el Cc en «Cc»; sin
 *     las direcciones propias y sin repetir a nadie.
 */
export function destinatariosDeRespuesta(msg, modo, propias = []) {
  const mias = new Set(propias.filter(Boolean).map((e) => e.toLowerCase()));
  const vistos = new Set();
  const tomar = (lista) => (lista || [])
    .map((x) => (typeof x === 'string' ? x : x?.email))
    .filter((e) => {
      const k = String(e || '').trim().toLowerCase();
      if (!k || mias.has(k) || vistos.has(k)) return false;
      vistos.add(k);
      return true;
    });

  const replyTo = (msg?.reply_to || []).filter((x) => x?.email);
  const autor = replyTo.length ? replyTo : [msg?.from].filter(Boolean);
  let to = tomar(autor);
  // Contestar un correo que envié yo: «Responder» va a quien se lo mandé, no a mí mismo.
  if (!to.length) to = tomar(msg?.to);
  // Y si me lo mandé a mí mismo, a mí: antes «Para» quedaba vacío (prueba E2E, 2026-10-05).
  if (!to.length && msg?.from?.email) to = [msg.from.email];
  if (modo !== 'replyAll') return { to, cc: [] };
  return { to: [...to, ...tomar(msg?.to)], cc: tomar(msg?.cc) };
}
